import babelpolyfill from 'babel-polyfill'
import Vue from 'vue'
import App from './App'
import ElementUI from 'element-ui'
import locale from 'element-ui/lib/locale/lang/en'
// import 'element-ui/lib/theme-default/index.css'
import 'element-ui/lib/theme-chalk/index.css'
import VueRouter from 'vue-router'
import store from './vuex/store'
import Vuex from 'vuex'
import  VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import 'font-awesome/css/font-awesome.min.css'
import routes from "./routes"
import Print from "./print"
import {defaultRoutes, nurseRoutes, doctorRoutes, warehouseAdminRoutes,superAdminRouter} from "./routes"

Vue.use(VueRouter);
Vue.use(ElementUI, {locale});
Vue.use(Vuex);
Vue.use(VueQuillEditor);
Vue.use(Print);


global.antRouter = '' //全局的路由

NProgress.configure({showSpinner: false});
const router = new VueRouter({
    routes
});
let addRouFlag = false;

router.beforeEach((to, from, next) => {
    NProgress.start();
    if (to.path === '/login') {
        //sessionStorage.removeItem('user');
    }
    let user = JSON.parse(sessionStorage.getItem('user'));
    if (!user && to.path !== '/login'&&to.path !== '/forgetPassword'&&to.path !== '/changePassword' && to.path.indexOf("/register") === -1) {
        next({path: '/login'})
    } else {
        if (user && !addRouFlag) {
            let role = user.roleId;

            addRouFlag = true;
            // 2.根据用户的角色、和需要动态展示的路由，生成符合用户角色的路由
            let menu = getMenuByRole(role);
            // 3.利用global属性，让渲染菜单的组件sideMeuns.vue重新生成左侧菜单
            global.antRouter = menu;
            // 4.将生成好的路由addRoutes
            router.addRoutes(menu);
            // 5.push之后，会重新进入到beforeEach的钩子里,直接进入第一个if判断
            router.push({path: to.path})
        }
        next();
    }
});

const getMenuByRole = (roleId) => {
    if (roleId === "1") {
        return defaultRoutes.concat(doctorRoutes);
    } else if (roleId === "2") {
        return defaultRoutes.concat(nurseRoutes);
    } else if (roleId === "3") {
        return defaultRoutes.concat(warehouseAdminRoutes);
    }else if(roleId==='0'){
        return defaultRoutes.concat(superAdminRouter);
    }
}

router.afterEach(transition => {
    NProgress.done();
});

new Vue({
    //el: '#app',
    //template: '<App/>',
    router,
    store,
    //components: { App }
    render: h => h(App)
}).$mount('#app')




// WEBPACK FOOTER //
// ./src/main.js